import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { LiaProjectDiagramSolid } from 'react-icons/lia';
import { BsCurrencyExchange } from 'react-icons/bs';
import { GrGroup } from 'react-icons/gr';
import { MdOutlineInventory } from 'react-icons/md';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { IoShieldOutline } from 'react-icons/io5';

const ProductSection = () => {
	const { t, tArray } = useLanguage();
	const features = tArray('product.features');

	const icons = [
		<LiaProjectDiagramSolid />,
		<BsCurrencyExchange />,
		<GrGroup />,
		<MdOutlineInventory />,
		<HiOutlineDocumentReport />,
		<IoShieldOutline />
	];

	return (
		<section id="product" className="landing-section">
			<div className="container-landing">
				<div className="text-center">
					<h2 className="section-title">{t('product.title')}</h2>
					<p className="section-subtitle">{t('product.subtitle')}</p>
				</div>

				<div className="product-grid">
					{features.map((feature, index) => (
						<div key={index} className="product-card">
							<div className="product-icon">{icons[index] || null}</div>
							<h3 className="product-title">{feature.title}</h3>
							<p className="product-description">{feature.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default ProductSection;
